import Dexie, { type EntityTable } from "dexie";
import type { Document, Occurrence, Collection, CollectionItem, ReviewItem, SyncState, SavedView, OpfsManifestEntry } from "@/types";

class AttachDriveDB extends Dexie {
  documents!: EntityTable<Document, "id">;
  occurrences!: EntityTable<Occurrence, "id">;
  collections!: EntityTable<Collection, "id">;
  collectionItems!: EntityTable<CollectionItem, "id">;
  reviewItems!: EntityTable<ReviewItem, "id">;
  syncState!: EntityTable<SyncState, "id">;
  savedViews!: EntityTable<SavedView, "id">;
  opfsManifest!: EntityTable<OpfsManifestEntry, "id">;

  constructor() {
    super("attachdrive");
    this.version(1).stores({
      documents: "++id, canonicalName, mimeType, extension, sizeBytes, contentHash, previewStatus, parseStatus, classification, createdAt, updatedAt",
      occurrences: "++id, documentId, provider, accountId, senderEmail, receivedAt, createdAt",
      collections: "++id, name, createdAt, updatedAt",
      collectionItems: "++id, collectionId, documentId",
      reviewItems: "++id, documentId, reason, status, createdAt, updatedAt",
      syncState: "++id, accountId, provider, status",
      savedViews: "++id, name, createdAt, updatedAt",
      opfsManifest: "++id, documentId",
    });
  }
}

export const db = new AttachDriveDB();
